// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 649px) {
    .roulette-container {
        transform:scale(0.6);
    }
}

@media screen and (min-width: 650px) {
    .roulette-container {
        transform:scale(1);
    }
}

.roulette-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: var(--roulette-table);
    border-radius: 0.5rem;
}

.roulette-board-container {
    display: flex;
    align-items: end;
    flex-direction: column;
    background: var(--roulette-table);
    padding:1rem;
}

.roulette-board {
    display: flex;
    align-items: center;
}

.roulette-board-numbers {
    display: flex;
    flex-direction: column;
}

.roulette-board-bottom-board {
    display: flex;
    justify-content: space-evenly;
}

.roulette-number-row {
    display: flex;
}

.roulette-number {
    font-size: 1.5rem;
    width: 3rem;
    height: 3rem;
    border: 2px var(--background) solid;
}

.roulette-number:hover {
    cursor: pointer;
}

.roulette-number.highlighted {
    color: var(--roulette-highlight);
}


.roulette-bet {
    font-size: 1.5rem;
    width: 6.25rem;
    height: 3rem;
    border: 2px var(--background) solid;
}

.roulette-bet:hover {
    cursor: pointer;
}

.roulette-number.red {
    background: var(--roulette-red);
}

.roulette-number.black {
    background: var(--roulette-black);
}

.vwl-container {
    display: flex;
    gap: 1rem;
    padding: 0.5rem;
    background: var(--roulette-table);
}

.vwl-label {
    opacity: 0.5;
    font-size: 1.5rem;
}

.vwl-value {
    font-size: 1.5rem;
}

input {
    color: white;
    width:10rem;
    border: 10px;
    background: var(--background);
}

.chip {
    position: relative;
    text-align: center;
}

/*.chip-text {*/
/*     position: absolute;*/
/*     top: 50%;*/
/*     left: 50%;*/
/*     transform: translate(-50%, -50%);*/
/*}*/

.chip-text {
    opacity: 0.8;
    font-size: 0.7em;
}

.warning {
    color: var(--logoShade2)
}`, "",{"version":3,"sources":["webpack://./src/roulette/components/roulette.css"],"names":[],"mappings":"AAAA;IACI;QAII,oBAAoB;IACxB;AACJ;;AAEA;IACI;QAII,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,eAAe;AACf,2BAA2B;AAC3B,iBAAiB;AACjB,kBAAkB;AAClB,yCAAyC;AACzC,IAAI;;AAEJ;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;AACJ","sourcesContent":["@media screen and (max-width: 649px) {\n    .roulette-container {\n        -webkit-transform:scale(0.6);\n        -moz-transform:scale(0.6);\n        -ms-transform:scale(0.6);\n        transform:scale(0.6);\n    }\n}\n\n@media screen and (min-width: 650px) {\n    .roulette-container {\n        -webkit-transform:scale(1);\n        -moz-transform:scale(1);\n        -ms-transform:scale(1);\n        transform:scale(1);\n    }\n}\n\n.roulette-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: var(--roulette-table);\n    border-radius: 0.5rem;\n}\n\n.roulette-board-container {\n    display: flex;\n    align-items: end;\n    flex-direction: column;\n    background: var(--roulette-table);\n    padding:1rem;\n}\n\n.roulette-board {\n    display: flex;\n    align-items: center;\n}\n\n.roulette-board-numbers {\n    display: flex;\n    flex-direction: column;\n}\n\n.roulette-board-bottom-board {\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.roulette-number-row {\n    display: flex;\n}\n\n.roulette-number {\n    font-size: 1.5rem;\n    width: 3rem;\n    height: 3rem;\n    border: 2px var(--background) solid;\n}\n\n.roulette-number:hover {\n    cursor: pointer;\n}\n\n.roulette-number.highlighted {\n    color: var(--roulette-highlight);\n}\n\n\n.roulette-bet {\n    font-size: 1.5rem;\n    width: 6.25rem;\n    height: 3rem;\n    border: 2px var(--background) solid;\n}\n\n.roulette-bet:hover {\n    cursor: pointer;\n}\n\n.roulette-number.red {\n    background: var(--roulette-red);\n}\n\n.roulette-number.black {\n    background: var(--roulette-black);\n}\n\n.vwl-container {\n    display: flex;\n    gap: 1rem;\n    padding: 0.5rem;\n    background: var(--roulette-table);\n}\n\n.vwl-label {\n    opacity: 0.5;\n    font-size: 1.5rem;\n}\n\n.vwl-value {\n    font-size: 1.5rem;\n}\n\ninput {\n    color: white;\n    width:10rem;\n    border: 10px;\n    background: var(--background);\n}\n\n.chip {\n    position: relative;\n    text-align: center;\n}\n\n/*.chip-text {*/\n/*     position: absolute;*/\n/*     top: 50%;*/\n/*     left: 50%;*/\n/*     transform: translate(-50%, -50%);*/\n/*}*/\n\n.chip-text {\n    opacity: 0.8;\n    font-size: 0.7em;\n}\n\n.warning {\n    color: var(--logoShade2)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
